import { Switch } from '@/components/ui/switch'
import { FieldTooltip } from '@/components/FieldLabel'
import { cn } from '@/lib/utils'

export interface SwitchFieldProps {
  label: string
  description?: string
  /** Explanatory help behind a hover icon, so the row stays a single line. */
  tooltip?: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
  className?: string
}

/** Boolean setting as a bordered row: label and help text left, switch right. */
export function SwitchField({
  label,
  description,
  tooltip,
  checked,
  onCheckedChange,
  disabled,
  className,
}: SwitchFieldProps) {
  return (
    <div className={cn('flex items-start justify-between gap-4 rounded-lg border p-3', className)}>
      <div className="flex flex-col gap-0.5">
        <span className="flex items-center gap-1.5 text-sm font-medium">
          {label}
          {tooltip && <FieldTooltip text={tooltip} />}
        </span>
        {description && <span className="text-xs text-muted-foreground">{description}</span>}
      </div>
      <Switch checked={checked} onCheckedChange={onCheckedChange} disabled={disabled} />
    </div>
  )
}
